import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { SigninComponent } from './common/signin/signin.component';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    SigninComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    CommonModule,
  ],
  providers: [],
  exports: [RouterModule],
  // AppComponent is a standalone component and is bootstrapped directly in main.ts
})
export class AppModule { }
